export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ05.967ddb49.mp3";